import * as React from "react";
import { locKeys } from "src/components/flexComponents/WizardPackagePWA/l10n";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkText } from "uitk-react-text";

export const ValuePropSubtitle = () => {
  const { formatText } = useLocalization();

  return (
    <>
      <UitkText size={300} spacing="six">
        {formatText(locKeys.packageValuePropSubtitle)}
      </UitkText>
    </>
  );
};
